import { ICountryRegionalItLead } from "../redux/slices/country-regional-it-leads";
import { callBffApi } from "./axios";

export const countryRegionalItLeadsService = {
  fetchCountryRegionalITLeads: async () => {
    const response = await callBffApi<{ data: ICountryRegionalItLead[] }>("get", "/country-regional-it-leads");
    return response.data;
  },
};
